module.exports = __webpack_public_path__ + "img/phone_screen_02@2x.9eb2ef74.png";